/* unplugin-vue-components disabled */import script from "./InvoiceProductNameSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceProductNameSelect.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceProductNameSelect.vue?vue&type=style&index=0&id=165e57ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165e57ba"]])

export default __exports__